export interface SerializableAudioBuffer {
    channels: Float32Array[];
    numberOfChannels: number;
    length: number;
    sampleRate: number;
}

export default class Mp3Encoder {
    static async encode(blob: Blob, workerFactory: () => Worker | Promise<Worker>, normalize = false): Promise<Blob> {
        // BS.1770 filter coefficients in the worker are defined at 48 kHz.
        const audioContext = new AudioContext(normalize ? { sampleRate: 48000 } : undefined);
        let audioBuffer: AudioBuffer;
        try {
            audioBuffer = await audioContext.decodeAudioData(await blob.arrayBuffer());
        } finally {
            await audioContext.close();
        }
        const channels = Array.from({ length: audioBuffer.numberOfChannels }, (_, i) => audioBuffer.getChannelData(i));
        const worker = await workerFactory();
        return new Promise((resolve, reject) => {
            worker.onmessage = (e) => {
                worker.terminate();
                if (e.data.error) {
                    reject(new Error(e.data.error));
                } else {
                    resolve(new Blob(e.data.buffer, { type: 'audio/mp3' }));
                }
            };
            worker.onerror = (e) => {
                worker.terminate();
                reject(e.error ?? new Error('MP3 encoding failed: ' + e.message));
            };
            worker.postMessage(
                {
                    command: 'encode',
                    normalize,
                    audioBuffer: {
                        channels,
                        numberOfChannels: audioBuffer.numberOfChannels,
                        length: audioBuffer.length,
                        sampleRate: audioBuffer.sampleRate,
                    },
                },
                channels.map((channel) => channel.buffer)
            );
        });
    }
}
